import styled from 'styled-components';

import { PaletteColor } from '@utils/types';
import { PriceFormat } from '@components/ui/price/type';

export const DiscountedPriceContainer = styled.span<{
  size: number;
}>`
  color: ${({ theme }) => theme.palette.pinkSwan};
  text-transform: uppercase;
  font-size: ${({ size }) => size}px;
  letter-spacing: 0.6px;
  font-weight: 600;
`;
export const OriginalPriceContainer = styled.span<{
  size: number;
  noLine?: boolean;
}>`
  color: ${({ theme }) => theme.palette.pinkSwan};
  text-decoration: ${({ noLine }) => (noLine ? 'none' : 'line-through')};
  text-transform: uppercase;
  font-size: ${({ size }) => size}px;
  letter-spacing: 0.6px;
  font-weight: 600;
`;

export const TourOriginalPriceContainer = styled.span<{
  size: number;
  noLine?: boolean;
}>`
  color: ${({ theme }) => theme.palette.pinkSwan};
  text-decoration: ${({ noLine }) => !noLine && 'line-through'};
  text-transform: uppercase;
  font-size: ${({ size }) => size}px;
  letter-spacing: 0.6px;
  font-weight: 600;
`;

export const Decimals = styled.span<{
  fontWeight?: number;
}>`
  font-weight: ${({ fontWeight }) => fontWeight};
`;
export const Currency = styled.span<{
  fontSize?: number;
  fontWeight?: number;
}>`
  text-transform: uppercase;
  margin-left: 3px;
  font-size: ${(p) => (p.fontSize ? `${p.fontSize}px` : 'inherit')};
  font-weight: ${(p) => (p.fontWeight ? p.fontWeight : 'inherit')};
`;
export const DecimalsCurrency = styled.div<{
  decimalCurrencyFlexDirection: 'row' | 'column';
}>`
  flex-direction: ${(p) => p.decimalCurrencyFlexDirection};
`;
const shouldApplyOpacity = (
  format: PriceFormat,
  allowedValues: PriceFormat[]
) => allowedValues.indexOf(format) > -1;
export const Container = styled.div<{
  color: PaletteColor;
  format: PriceFormat;
  centered: boolean;
  decimalFontSize: number;
}>`
  color: ${({ theme, color }) => theme.palette[color]};
  font-size: ${(p) => p.decimalFontSize}px;
  font-weight: 600;
  display: flex;
  align-items: ${(p) => (p.centered ? 'center' : 'unset')};
  opacity: ${(p) => (shouldApplyOpacity(p.format, ['payment']) ? 0.75 : 1)};
  ${DecimalsCurrency} {
    margin-left: 3px;
    align-self: center;
    opacity: ${(p) =>
      shouldApplyOpacity(p.format, ['discount', 'payment']) ? 0.75 : 1};
  }
`;
export const Whole = styled.span<{
  fontSize: number;
  fontWeight: number;
}>`
  font-size: ${({ fontSize }) => fontSize}px;
  font-weight: ${({ fontWeight }) => fontWeight};
  color: ${({ theme }) => theme.palette.NL800};
  line-height: 1;
`;

export const WithOriginalPrice = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;

  ${Container} {
    flex: 1;
    ${Whole} {
      line-height: 1;
    }
  }
`;
